import axios from "axios";
import { config } from "../config";
const baseUrl = window.baseUrl;
const responseBody = (response) => response;

(async () => {
    axios.interceptors.request.use(
        function (req) {
            const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJBZG1pbkBnbWFpbC5jb20iLCJqdGkiOiJkN2YzMmNkMi1iZDM1LTQ5OTgtOWQyNS1jZTEzYmQzNzA4YTkiLCJpYXQiOjE2NDQ2OTA0ODQsInJvbCI6IkFkbWluIiwiaWQiOiI2IiwiVXNlcklkIjoiQWRtaW5AZ21haWwuY29tIiwiRW1haWwiOiJBZG1pbkBnbWFpbC5jb20iLCJuYmYiOjE2NDQ2OTA0ODMsImV4cCI6MTY3NTc5NDQ4MywiaXNzIjoibG9jYWxob3N0OjYyMTE3IiwiYXVkIjoibG9jYWxob3N0OjYyMTE3In0.f-T5SL9p2-FtKkRSxzxtE6GM1_2aKtHysMkqiy0M_Vw';
            req.headers['Authorization'] = `Bearer ${token}`;
            req.time = { startTime: new Date() };
            return req;
        },
        (err) => {
            return Promise.reject(err);
        }
    );
    axios.interceptors.response.use(
        function (res) {
            res.config.time.endTime = new Date();
            res.duration = res.config.time.endTime - res.config.time.startTime;
            return res;
        },
        (err) => {
            return Promise.reject(err);
        }
    );
})();
const action = {
    get: (url, params, header) =>
        axios.get(baseUrl + url, { 'headers': header || {}, 'params': params }).then((responseBody) => {
            return responseBody;
        }),
    post: (url, body) => axios.post(baseUrl + url, body).then((responseBody) => {
        return responseBody
    }),
    put: (url, body) => axios.put(baseUrl + url, body).then((responseBody) => {
        return responseBody
    }),
    del: (url, params, header) => axios.delete(baseUrl + url, { 'headers': header || {}, 'params': params }).then((responseBody) => {
        return responseBody
    }),
    postForm: (url, file) => {
        let formData = new FormData();
        formData.append("File", file);
        return axios
            .post(url, formData, {
                headers: { "Content-type": "multipart/form-data" },
            })
            .then((responseBody) => {
                return responseBody
            });
    },
};

export default {
    action,
};